import AddressBlock from "@components/shared/AddressBlock/AddressBlock";
import AddressDisplay from "@components/shared/AddressDisplay/AddressDisplay";
import OwEditModeToggle from "@components/shared/OwEditModeToggle/OwEditModeToggle";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import IAddress from "@models/IAddress";
import IOrder from "@models/IOrder";
import { useState } from "react";

type Props = {
    order: IOrder;
    isReadOnly: boolean;
};

export const EcommerceOrderCheckoutShipTo = (props: Props) => {
    const [editMode, setEditMode] = useState(false);
    const [address, setAddress] = useState<IAddress | undefined>(props.order.Ship_To);

    return (
        <div className={"EcommerceOrderCheckoutShipTo"}>
            <div>
                <div className="d-flex align-items-center">
                    <OwTitle title={"1_shipping"} tag="h5" isUnderline={true} />
                    {!props.isReadOnly && (
                        <div className="mb-2 mt-2">
                            <OwEditModeToggle
                                className="ms-2"
                                editMode={editMode}
                                cancelEditFn={() => setEditMode(false)}
                                saveEditFn={() => setEditMode(false)}
                                toggleEditFn={() => setEditMode(!editMode)}
                            />
                        </div>
                    )}
                </div>

                {editMode ? (
                    <AddressBlock showName={true} showCompanyName={true} address={address} fn={setAddress} />
                ) : (
                    <AddressDisplay showName={true} showCompanyName={true} address={address} />
                )}
            </div>
        </div>
    );
};
